var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 570,
    height: 570,
    viewBox: "0 0 570 570",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.3382 28.9442C43.1538 28.9442 17.5342 54.6747 17.5342 88.4939C17.5342 121.566 42.3906 148.031 80.8346 148.031H81.5783C121.529 148.031 146.392 121.566 146.392 88.4939C145.645 54.6747 121.529 28.9442 82.3382 28.9442V28.9442Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3052 195.085H138.858V539.722H24.3052V195.085Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M420.031 186.996C358.234 186.996 316.796 245.065 316.796 245.065V195.085H202.24V539.722H316.789V347.263C316.789 336.96 317.536 326.673 320.563 319.305C328.844 298.731 347.69 277.417 379.337 277.417C420.788 277.417 437.366 309.021 437.366 355.352V539.722H551.909V342.113C551.909 236.256 495.393 186.996 420.031 186.996V186.996Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.2cb669d38a4d5bfee6c13acd512c9bc0.svg";
export { ForwardRef as ReactComponent };